<template>
  <div id="app" class="appZone">
    <b-container>
      <b-row>
        <router-view v-if="show" />
        <b-col cols="12" v-if="error">
          <b-alert variant="danger" show>Something went wrong with initializing the web component. Please contact <a href="mailto:ewillems@educam.be">Educam support</a> for help.</b-alert>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import i18nConfig from '@/i18n/i18n'
import EducamApi from '@/axios/educam-api.instance'
import Mailer from '@/mixins/Mailer'

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
Vue.config.productionTip = false

const i18n = new VueI18n(i18nConfig)

export default {
  mixins: [Mailer],
  mounted () {
    i18n.locale = this.language
    this.$store.dispatch('setLanguage', this.language)
  },
  data () {
    return {
      show: false,
      error: false
    }
  },
  props: {
    token: {
      type: String,
      // required: false,
      // default: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb21wb25lbnRJZCI6MTcsImNvbXBhbnlJZCI6Mn0.jMcCmAXRIp64DPHY55DpfOU4WdRFOIK9p27LGVw0bFw'
      required: true,
      default: ''
    },
    language: {
      type: String,
      default: 'nl',
      required: false
    }
  },
  methods: {
    setStyles () {
      const root = document.documentElement
      root.style.setProperty('--font-color', this.$store.getters.componentData.css_font_color)
      root.style.setProperty('--font-family', this.$store.getters.componentData.css_font_family)
      root.style.setProperty('--btn_bg_color', this.$store.getters.componentData.css_btn_bg_color)
      root.style.setProperty('--btn_color', this.$store.getters.componentData.css_btn_color)
    }
  },
  beforeMount () {
    EducamApi.post('courses/component-init', {
      token: this.token
    }).then(response => {
      this.$store.dispatch('setComponentData', response.data.detail)

      if (response.data.detail.course_types_id === parseInt(process.env.VUE_APP_COURSE_TYPE_COMPANIES_ILIAS) && this.$route.name !== 'CompanyConcept') {
        this.$router.push({ name: 'CompanyConcept' })
      }

      if (response.data.detail.course_types_id === parseInt(process.env.VUE_APP_COURSE_TYPE_ILIAS) && this.$route.name !== 'Ilias') {
        this.$router.push({ name: 'Ilias' })
      }

      this.show = true

      this.$store.dispatch('setLanguage', this.language)
      this.setStyles()
    }).catch(err => {
      this.error = true
      console.log(err)
    })
  },
  name: 'App',
  router,
  i18n,
  store
}
</script>

<style>
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import 'assets/css/style.scss';

:root {
  --font-color: #ff0000;
  --font-family: 'Arial';
  --btn_bg_color: #FF0000;
  --btn_color: #000000;
}
</style>
